// extracted by css-extract-rspack-plugin
export default {"mobileTileContainer":"_3a158eea"};